import React from "react"
import avatar from "avatar/zen-sad.svg"

const ZenSad = (props) => <img src={avatar} className="avatar" {...props} />

export default ZenSad
